import AddListsIntoPage from './AddListsIntoPage';

const GetDataEntryFormFromFormNameConfig = (formName, forms, pages, lists) => {

    let formDef = forms.filter(f => f.Name === formName)[0];

    let pagesList = [...formDef.Pages];

    const newFormDef = {...formDef};

    newFormDef.Pages = [];
    for (const page of pagesList) {
        let newPage = pages.filter(p => p.Name === page)[0];
        if (newPage !== undefined) {
            newPage = AddListsIntoPage(newPage, lists);
            newFormDef.Pages.push(newPage);
        }
    }

    return newFormDef;
}

export default GetDataEntryFormFromFormNameConfig;